import { MoreVertical, Pencil, RotateCcw, Trash2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { cn } from "@/lib/utils";

export interface LeadActions {
  onEdit?: () => void;
  onDelete?: () => void;
  /** Ausente em lead perdido/entregue. */
  onMarkLost?: () => void;
  /** Só em lead perdido. */
  onReopen?: () => void;
}

/** Menu "Mais ações" de um lead — card do funil e linha da tabela. */
export function LeadActionsMenu({
  leadName,
  onEdit,
  onDelete,
  onMarkLost,
  onReopen,
  className,
}: LeadActions & { leadName: string; className?: string }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={cn("h-6 w-6 shrink-0", className)}
          aria-label={`Mais ações para ${leadName}`}
        >
          <MoreVertical className="h-3.5 w-3.5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={onEdit}>
          <Pencil className="mr-2 h-3.5 w-3.5" /> Editar
        </DropdownMenuItem>
        {onMarkLost && (
          <DropdownMenuItem onClick={onMarkLost} className="text-bad focus:text-bad">
            <XCircle className="mr-2 h-3.5 w-3.5" /> Marcar como perdido…
          </DropdownMenuItem>
        )}
        {onReopen && (
          <DropdownMenuItem onClick={onReopen}>
            <RotateCcw className="mr-2 h-3.5 w-3.5" /> Reabrir lead
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={onDelete} className="text-destructive focus:text-destructive">
          <Trash2 className="mr-2 h-3.5 w-3.5" /> Excluir…
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
